// FASE 17 — Central role-based UI permission map (RBAC por perfil e unidade)
const ALL = {
  // menus
  dashboard: true,
  corporate: true,
  checklists: true,
  executions: true,
  schedules: true,
  occurrences: true,
  rules: true,
  notifications: true,
  units: true,
  users: true,
  teamRanking: true,
  appcc: true,
  audits: true,
  trainings: true,
  equipment: true,
  sanitary: true,
  consumptions: true,
  reports: true,
  chatbot: true,
  pricing: true,
  settings: true,
  support: true,
  integrations: true,
  timeclock: true,
  timeclockAdmin: true,
  // dashboard widgets
  planCard: true,
  kpiCards: true,
  topUnits: true,
  analytics: true,
  predictive: true,
  recentSupport: true,
  myDay: false,
  // actions
  createTemplates: true,
  createUsers: true,
  createPccs: true,
  createTrainings: true,
  companyTab: true,
  bellTickets: true,
  reportsAuditsOnly: false,
};

const NONE = Object.fromEntries(Object.keys(ALL).map((k) => [k, false]));

const PERMS = {
  super_admin: { ...NONE, settings: true },
  timeclock_kiosk: { ...NONE },
  company_admin: { ...ALL },
  manager: {
    ...ALL,
    corporate: false,
    units: false,
    pricing: false,
    support: false,
    planCard: false,
    recentSupport: false,
    bellTickets: false,
  },
  supervisor: {
    ...ALL,
    corporate: false,
    units: false,
    pricing: false,
    support: false,
    planCard: false,
    recentSupport: false,
    bellTickets: false,
    createUsers: false,
  },
  operator: {
    ...NONE,
    dashboard: true,
    checklists: true,
    executions: true,
    appcc: true,
    trainings: true,
    chatbot: true,
    settings: true,
    integrations: true,
    timeclock: true,
    myDay: true,
  },
  auditor: {
    ...NONE,
    dashboard: true,
    checklists: true,
    executions: true,
    appcc: true,
    audits: true,
    trainings: true,
    reports: true,
    chatbot: true,
    settings: true,
    integrations: true,
    timeclock: true,
    kpiCards: true,
    analytics: true,
    predictive: true,
    myDay: true,
    reportsAuditsOnly: true,
  },
};

export function getPerms(role) {
  return PERMS[role] || PERMS.operator;
}
